'use strict';

let isMobile = require('.././utilities/clientSideUtil').isMobile;

module.exports = {
    heroBannerBackgroundLink: function () {
        let startClickX;
        let startClickY;
        let isSwipe = false;
        const SWIPE_THRESHOLD = 8;

        $(document).on("mousedown touchstart", ".clickable-mbb-hero-js", function (e) {
            e.preventDefault();
            const currentPosition = e.type === "touchstart" ? e.originalEvent.touches[0] : e;
            startClickX = currentPosition.clientX;
            startClickY = currentPosition.clientY;
            isSwipe = false;
        })
        $(document).on("mousemove touchmove", ".clickable-mbb-hero-js", function (e) {
            e.preventDefault();
            if (startClickX == null) return;
            const currentPosition = e.type.startsWith("touch") ? e.originalEvent.touches[0] : e;
            if (Math.abs(currentPosition.clientX - startClickX) > SWIPE_THRESHOLD || Math.abs(currentPosition.clientY - startClickY) > SWIPE_THRESHOLD) {
                isSwipe = true;
            }
        })
        $(document).on("mouseup touchend", ".clickable-mbb-hero-js", function () {
            startClickX = null;
            startClickY = null;
        })
        
        $(document).on('click', '.clickable-mbb-hero-js', function (e) {
            if (!isSwipe && $(e.target).parent('.cta-container').length === 0 && $(e.target).parent('.glide__container').length === 0) {
                window.location.href = $(this).data('target');
            }
        })
        
    },

    loadHeroImageBasedOnViewPort : function () {
        $(window).on('load', function () {
            var heroImages  =  $('.mbb-hero-js').find('.hero-image-js');

            if (heroImages.length > 0) {
                heroImages.each(function () {
                    var $img = $(this);
                    
                    var focalX =  isMobile() && $img.data('focal-mobile-x') !== null ?  $img.data('focal-mobile-x') : $img.data('focal-desktop-x');
                    
                    var focalY =  isMobile() && $img.data('focal-mobile-y') !== null ? $img.data('focal-mobile-y') : $img.data('focal-desktop-y');

                    if (focalX.length > 0) {
                        $img.css("--focal-point-x", focalX);
                    }

                    if (focalY.length > 0) {
                        $img.css("--focal-point-y", focalY);
                    }
                });
            }
        })    
    }
};
